import { z } from 'zod';
import {
  CHECKOUT_PAYMENT_ROUTE,
  CHECKOUT_SHIPPING_ROUTE,
  CYO_ROUTE,
  HOMEPAGE_ROUTE,
  PRECHECKOUT_PLAN_ROUTE,
  ROUTE_SIGN_UP,
  ROUTE_QUIZ_BUILDING,
} from '@hungryroot/routes';
import {
  allMiniQuizRoutes,
  type AllMiniQuizRoutes,
} from '../defs/mini-quiz-routes';
import { allQuizRoutes } from '../defs/routes';

const preSignUpRoutes = [
  HOMEPAGE_ROUTE,
  ROUTE_QUIZ_BUILDING,
  ROUTE_SIGN_UP,
  ...allQuizRoutes,
] as const;

export const postSignUpRoutes = [
  CYO_ROUTE,
  CHECKOUT_SHIPPING_ROUTE,
  CHECKOUT_PAYMENT_ROUTE,
  PRECHECKOUT_PLAN_ROUTE,
] as const;

// All of the funnel routes
// This is not an ordered list
// Its just a list of all the routes in the funnel
const funnelRoutes = [...preSignUpRoutes, ...postSignUpRoutes] as const;

export type AllFunnelRoutes = (typeof funnelRoutes)[number];

export const funnelRoutesSchema = z.enum(funnelRoutes);

const miniQuizRoutes = allMiniQuizRoutes as [
  AllMiniQuizRoutes,
  ...AllMiniQuizRoutes[],
];

export const miniQuizRoutesSchema = z.enum(miniQuizRoutes);
